import { useChainId, usePublicClient } from 'wagmi'
import { useAccount } from './useAccount'
import { useQuery } from '@tanstack/react-query'
import type { EIP1193RequestFn } from 'viem'
import { usingBigBlocksRpcSchema, type UsingBigBlocksRpcSchema } from '@/domain/rpc/schemas'

export function useIsUsingBigBlocks() {
  const account = useAccount()
  const chainId = useChainId()
  const publicClient = usePublicClient()

  const query = useQuery({
    queryKey: ['bigBlocks', account, chainId],
    queryFn: async () => {
      if (!account || !publicClient) {
        return false
      }

      const clientWithSchema = publicClient as typeof publicClient & {
        request: EIP1193RequestFn<UsingBigBlocksRpcSchema>
      }

      const usingBigBlocks = await clientWithSchema.request({
        method: 'eth_usingBigBlocks',
        params: [account],
        rpcSchema: usingBigBlocksRpcSchema,
      })

      return usingBigBlocks
    },
    refetchInterval: false,
    enabled: Boolean(account),
  })

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  }
}
